import Header from 'apps/employer_renewals/components/Header'
import NavigationButtons from 'apps/employer_renewals/components/NavigationButtons'
import useAppNavigation from 'apps/employer_renewals/hooks/useAppNavigation'
import { useHasFinalizedPricing } from 'apps/employer_renewals/providers/EmployerProvider'
import { EmployerRenewalsRoute } from 'apps/employer_renewals/routes'

import PageContainer from '../../components/layout/PageContainer'

type PageCopy = {
  heading: string
  subheading: string
}

const preliminaryCopy: PageCopy = {
  heading: 'Time to review your 2026 Thatch allowance strategy',
  subheading: "We'll walk through your projected 2026 costs so that you can continue giving your team great healthcare in 2026.",
}

const finalizedCopy: PageCopy = {
  heading: 'Time to review your 2026 Thatch allowance strategy',
  subheading: "We'll walk through your estimated 2026 costs so that you can continue giving your team great healthcare in 2026.",
}

export default function IntroPage () {
  const { navigateTo, goToDashboard } = useAppNavigation()
  const hasFinalizedPricing = useHasFinalizedPricing()

  const pageCopy = hasFinalizedPricing ? finalizedCopy : preliminaryCopy

  return (
    <PageContainer maxWidth='lg' verticallyCentered>
      <Header
        heading={pageCopy.heading}
        subheading={pageCopy.subheading}
      />
      <NavigationButtons
        nextButtonText="Great, let's start"
        onNext={() => { navigateTo(EmployerRenewalsRoute.WHAT_TO_EXPECT) }}
        backButtonText='Back to dashboard'
        onBack={() => { goToDashboard() }}
      />
    </PageContainer>
  )
}
